import { useHistory } from "react-router-dom";
import Actions from "./Actions";

const Board = props => {

    const {
        id,
        lesson,
        user,
        comment,
        accepted,
        replies,
        course,
        file,
        onUpdate = () => {}
    } = props;

    const history = useHistory();

    return (
        <tr>
            <td>{lesson?.title}</td>
            <td>{file?.name}</td>
            <td>
                <button
                    type="button"
                    onClick={() => history.push(`/profile/view/${user?.id}`)}
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "inherit",
                        cursor: "pointer",
                        padding: 0,
                        textDecoration: "underline"
                    }}
                >
                    {user?.name}
                </button>
            </td>
            <td className={"table-text-dots"}>{comment}</td>
            <td>{accepted ? "Aprovado" : "Pendente"}</td>
            <Actions
                id={id}
                comment={comment}
                replies={replies}
                user={user}
                lesson={lesson}
                onUpdate={onUpdate}
                accepted={accepted}
                courseId={course?.id}
                fileId={file?.id}
            />
        </tr>
    );
}

export default Board;
